import React from "react";
import Sucursales from "./pages/Sucursales";

function App() {
  return (
    <div className="min-h-screen bg-night text-white">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-night/95 px-6 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-3">
          <img
            src="/NebulaLogo.png"
            alt="Nebula Manager"
            className="h-8 w-auto object-contain"
          />
          <span className="ml-auto hidden text-sm font-normal text-white/50 sm:block">
            Panel de administración de despliegues
          </span>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">
        <Sucursales />
      </main>
    </div>
  );
}

export default App;